export type Locale = 'ru'

export const LOCALE_STORAGE_KEY = 'prime-shop-locale'

const messages = {
	ru: {
		button: 'go to bot',
		botsUnavailable:
			'Оставайтесь с нами — все наши боты временно недоступны. Сохраните эту страницу и загляните позже',
		notice:
			'Здесь вы найдете актуальные ссылки на нашего бота и сайт. Сохраните эту вкладку, чтобы всегда иметь к ним доступ',
		langRu: 'RU',
		langEn: 'ENG',
		langSwitch: 'Язык',
		
		// New strings for the two blocks
		siteTitle: 'ПЕРЕЙТИ НА САЙТ',
		siteDesc: 'Войдите в наш магазин и откройте для себя эксклюзивные предложения',
		siteBtn: '▶ НАЖМИТЕ ЗДЕСЬ ↗',
		
		botTitle: 'ПЕРЕЙТИ В БОТА',
		botDesc: 'Откройте нашего бота для доступа к полному функционалу',
		botBtn: '⚡ ОТКРЫТЬ БОТА ↗',
	},
} as const satisfies Record<Locale, Record<string, string>>

export function t(locale: Locale) {
	return messages[locale]
}

export function readStoredLocale(): Locale {
	try {
		const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
		if (stored === 'ru') return stored
	} catch (error) {
		console.error('Failed to read locale from storage:', error)
	}
	return 'ru'
}
